import { SxProps } from '@mui/material'
import StylesSearchServiceInterface from '~/src/pages/search/styles/StylesSearchServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesSearchServiceStyleTwo extends TemplateServiceStyleBase implements StylesSearchServiceInterface {
  public getPageSx(): SxProps {
    return {
      pt: 4,
      [this.muiTheme.breakpoints.down('md')]: {
        pt: 0
      }
    }
  }

  public getTitleSx(): SxProps {
    return {
      fontWeight: 600,
      pb: 4,
      color: 'background.contrastText',
      [this.muiTheme.breakpoints.down('md')]: {
        p: 2,
        pt: 0
      }
    }
  }
}
